// Added by Sejune Oh on 2020-06-08
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import { Day } from './index'

/**
 *  [1] Interface
 *  [2] Type
 *  [3] Enum
 *  [4] Constants
 */

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// # [1] Interface
export interface APSEngine {
  name: string
  display_name: string
  visible: boolean
  group: string
  params: APSEngineParam[]
}

export interface APSEngineParam {
  name: string
  value: string
  type?: APSEngineParamType
  possible_values?: string
}

export interface APSCondition {
  level: 'STUDY' | 'SERIES'
  tag_name: string
  tag_display_name: string
  items: APSOperation[]
}

export interface APSOperation {
  operation_name: APSOperationNameType
  value: string
  type: APSOperationType
  possible_values: string
}

export interface APSRule {
  id?: string
  fk_data_storage_id?: string
  name?: string
  description?: string
  aps_engine?: string
  conditions?: string
  aps_engine_param?: string
  study_status_after_completion?: string
  study_tag_after_completion?: string[]
  enable?: boolean
  group?: string
  order?: string
  created_at?: string
  updated_at?: string
  // 가동 시간
  schedule_items?: APSScheduleItem[]
}

export interface APSScheduleItem {
  possible_days_of_week: Day[]
  possible_time_from: string
  possible_time_to: string
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// # [2] Type
export type APSEngineParamType = 'string' | 'enum' | 'bool' | 'int' | 'real'

export type APSOperationNameType = 'HAS' | 'MATCHES' | 'RANGE' | 'CONTAINS' | 'REGEXP'

export type APSOperationType = 'string' | 'int' | 'list' | 'date' | 'datetime'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// # [3] Enum

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// # [4] Constants
export const UNCATEGORIZED_APS_ENGINE_GROUP = 'uncategorized'
